import { createFileRoute, redirect } from '@tanstack/react-router'

import { HeaderComponent } from '@/containers/onDemandPay'
import { featureEnabled } from '@/lib/feature-flag'
import { onDemandPayCardQueryOptions } from '@/queries/card'
import {
  ewaBranchVerificationQueryOptions,
  ewaPayrollScheduleQueryOptions,
  ewaTransactionBalanceQueryOptions,
} from '@/queries/ewa'
import { orgInfoQueryOptions } from '@/queries/organization'
import { RouteContext } from '@/routes/__root'
import { selectOrgData } from '@/selectors/organization'

const onDemandPayFeatureEnabled = featureEnabled('VITE_DIRECT_EWA_ENABLED')

export const Route = createFileRoute(
  '/_authenticated/account/_dashboard/onDemandPay'
)({
  beforeLoad: async ({ context: { queryClient, orgStore } }) => {
    const data = queryClient.getQueryData(
      orgInfoQueryOptions(orgStore.getState().orgId).queryKey
    )
    const { usesEarnings, directEwaEnabled } = selectOrgData(data)

    if (!directEwaEnabled || !onDemandPayFeatureEnabled) {
      redirect({ to: '/account', throw: true })
    }
    queryClient.ensureQueryData(onDemandPayCardQueryOptions())
    const promises = [
      queryClient.ensureQueryData(ewaBranchVerificationQueryOptions),
      queryClient.ensureQueryData(ewaTransactionBalanceQueryOptions),
      queryClient.ensureQueryData(ewaPayrollScheduleQueryOptions),
    ]
    await Promise.all(promises)
    const routeContext: Pick<RouteContext, 'HeaderComponent' | 'subNavLinks'> =
      {
        HeaderComponent: HeaderComponent,
        subNavLinks: [
          {
            to: '/account/onDemandPay',
            activeOptions: { exact: true, includeSearch: false },
            label: 'Advance Activity',
          },
          {
            to: '/account/onDemandPay/reportedWork',
            activeOptions: { includeSearch: false },
            label: `Reported ${usesEarnings ? 'Earnings' : 'Hours'}`,
          },
        ],
      }
    return routeContext
  },
})
